export const getNumberOfRows = ({count}: {count: number}) => {
    if (count <= 3) {
        return 3;
    }

    return Math.ceil(count / (count >= 8 ? 3 : 2));
};
